import { render, staticRenderFns } from "./repairForm.vue?vue&type=template&id=32ae6eb2&scoped=true&"
import script from "./repairForm.vue?vue&type=script&lang=js&"
export * from "./repairForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae6eb2",
  null
  
)

export default component.exports